import { useMemoMergePropsWithDefault } from '@elliemae/ds-legacy-props-helpers';
import { useConfiguredDefaultProps } from './useConfiguredDefaultProps.js';
import type { DSPopperJST } from '../react-desc-prop-types.js';

interface UseConfiguredMergedPropsT {
  props: DSPopperJST.Props;
  arrowElement: HTMLDivElement | null;
}

export const useConfiguredMergedProps = ({ props, arrowElement }: UseConfiguredMergedPropsT) => {
  const defaultProps = useConfiguredDefaultProps({ props, arrowElement });

  return useMemoMergePropsWithDefault<DSPopperJST.InternalProps>(props, defaultProps);
};
